import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import TinyNodeDataTable from '../components/TinyNodeDataTable';

import TinyNodeDataModel from '../components/TinyNodeDataModel';

import { Layout, Button, Row, Col, Input, Icon, DatePicker, message } from 'antd';

class TinyNodeDataScreen extends Component {

  state = {
    dataLoading: true,
    dataAll: [],
    data: [],
    dateFrom: moment().subtract(30, 'minutes'),
    dateTo: moment().endOf('day')
  }

  componentWillMount() {
    this.loadData(this.state.dateFrom, this.state.dateTo);
  }

  loadData(dateFrom = null, dateTo = null) {
    dateFrom = dateFrom ? dateFrom.format() : null;
    dateTo = dateTo ? dateTo.format() : null;
    this.setState({
      dataLoading: true
    });
    TinyNodeDataModel.getAll(dateFrom, dateTo)
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      });
  }

  onSearch(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => {
        return d.nodeID.toString().startsWith(searchText);
      })
    });
  }

  onDateRangeChanged(dates, dateStrings) {
    this.setState({
      dateFrom: dates[0],
      dateTo: dates[1]
    });
    this.loadData(dates[0], dates[1]);
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>TinyNode - Data</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={16}>
                <Input.Search
                  placeholder="Najít seriové číslo"
                  onSearch={this.onSearch.bind(this)}
                  style={{ width: 300 }} />
                {' '}
                <DatePicker.RangePicker
                  defaultValue={[
                    this.state.dateFrom,
                    this.state.dateTo
                  ]}
                  ranges={{
                    "Dnes": [moment().startOf('day'), moment().endOf('day')],
                    "Včera": [moment().add(-1, 'days').startOf('day'), moment().add(-1, 'days').endOf('day')],
                    "Poslední týden": [moment().add(-7, 'days').startOf('day'), moment().endOf('day')],
                  }}
                  allowClear={false}
                  placeholder={['Od', 'Do']}
                  format="DD.MM.YYYY HH:mm"
                  showTime={{ format: 'HH:mm' }}
                  onOk={this.onDateRangeChanged.bind(this)}
                  style={{ width: 300 }} />
              </Col>
              <Col span={8} style={{ textAlign: 'right' }}>
                <Button type="default" onClick={() => { this.loadData(this.state.dateFrom, this.state.dateTo) }} style={{ marginRight: 10 }}><Icon type="sync" /></Button>
              </Col>
            </Row>
          </div>
          <TinyNodeDataTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onDetailRow={(record) => {
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default TinyNodeDataScreen;



// WEBPACK FOOTER //
// ./src/screens/TinyNodeDataScreen.js